<div class="container">
  <mat-card appearance="outlined">
      <mat-card-title class="btn btn-rose">Add New Brand</mat-card-title>
      <mat-card-subtitle></mat-card-subtitle>
      <mat-card-content>
          <form [formGroup]="addBrandForm" (ngSubmit)="addBrandForm.valid && saveBrand()" novalidate>
              <div class="row">
                  <div class="col-12 col-sm-12 col-md-6">
                    
                      <mat-form-field color="accent" appearance="fill" color="accent">
                        <mat-label>Brand Name</mat-label>
                          <input matInput type="text" placeholder="BrandName" name="brandName" id="brandName"
                              formControlName="brandName" autocomplete="off" appInputValidator [sanitizeScriptTags]="true"
                               [hasAtLeastOneAlphabet]="true">
                              <mat-error *ngIf="addBrandForm.get('brandName').hasError('required')">
                                Brand Name is required.
                              </mat-error>
                              <mat-error *ngIf="addBrandForm.get('brandName').hasError('maxlength')">
                                Brand Name cannot be more than 50 characters.
                              </mat-error>
                               <mat-error *ngIf="addBrandForm.get('brandName').hasError('noAlphabet')">
                                 Must contain at least one alphabet.
                               </mat-error>
                      </mat-form-field>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6">
                      
                      <mat-form-field color="accent" appearance="fill" color="accent">
                        <mat-label>Description</mat-label>
                          <input matInput type="text" placeholder="Description" name="description" id="description"
                              formControlName="description" autocomplete="off"  appInputValidator [sanitizeScriptTags]="true"
                               [hasAtLeastOneAlphabet]="true">
                              <mat-error *ngIf="addBrandForm.get('description').hasError('required')">
                                Brand Description is required.
                              </mat-error>
                              <mat-error *ngIf="addBrandForm.get('description').hasError('maxlength')">
                                Description cannot be more than 100 characters.
                              </mat-error>
                                <mat-error *ngIf="addBrandForm.get('description').hasError('noAlphabet')">
                                 Must contain at least one alphabet.
                               </mat-error>
                      </mat-form-field>
                  </div>
              </div>
          </form>
      </mat-card-content>
      <mat-card-footer>
          <div class="row action-btn justify-content-center">
              <div class="col-12 col-sm-12 col-md-6">
                  <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                      (click)="close()">Close</button>
              </div>
              <div class="col-12 col-sm-12 col-md-6">
                  <button md-raised-button type="button" class="btn btn-round btn-block btn-rose" (click)="saveBrand()"
                      [disabled]="!addBrandForm.valid">Save</button>
              </div>
          </div>
      </mat-card-footer>
  </mat-card>
</div>

  
